<template>
  <app-base
    :show-config-button="false"
    show-image-finder
    show-setting-shell
  >
    <modal-migration
      :farmacloud-migration-url="farmacloudMigrationUrl"
    />
  </app-base>
</template>

<script setup>
import AppBase from '../common/AppBase'
import ModalMigration from '@/components/ModalMigration'
import { useShellStore } from '@/store'
import { computed } from 'vue'

const shellStore = useShellStore()
const farmacloudMigrationUrl = computed(() => shellStore.farmacloudMigrationUrl)
</script>
